import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import config from '../config';
import en from './en';

const resources = {
  en: {
    translation: en,
  },
};

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  // Technical Debt: Move config on upper level
  // returnNull: config.I18N_RETURN_NULL || false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
